import { Popover, Row, Space, Upload, Flex, Breadcrumb, Card, Button } from "antd";
import { Form, Formik } from "formik";
import { useState } from "react";
import {
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import Addressinformation from "components/elements/AddressInformation/AddressInformation";
import CompanyInfo from "components/elements/CompanyInfo/CompanyInfo";
import ContactInfo from "components/elements/ContactInfo/ContactInfo";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";

import infoSchema, {
  initialValues as infoInitialValues,
} from "../schemas/companyProfileInfoSchema";
import styles from "../styles/CompanyProfileCreate.module.css";
import * as service from "../services/companyApi"
import { getBase64 } from "components/elements/upload/Upload.utils";
import { dataURLtoFile } from "utils/helper";

const CompanyProfileCreate = ({
  currentStep = 0,
  infoValues = {},
  addressValues = {},
  contactValues = {},
  companyTypeOptions = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  // prevStep = () => { },
  onCancel = () => { },
  handleProviceChange = () => { },
  handleDistrictChange = () => { },
  // onCompanyInfoSubmit = () => { },
  // onCompanyAddressSubmit = () => { },
  // onCompanyContactSubmit = () => { },
  onCompanyCreateSubmit = () => { },
  getTaxConpanyOption = () => { },
  optionSearchTax = []
}) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const { t } = useTranslation();
  function fnPic(params) {
    console.log("params", params);
    if (params) {
      const decodedString = atob(params);
      let bytes = new Uint8Array(decodedString.length);
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = decodedString.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: 'image/png' });
      console.log("blob", blob);
      return blob;
    }
  }
  const customDot = (dot, { status, index }) => {
    return (
      <Popover
        content={
          <span>
            {t("step.step")} {index + 1} {t("step.status")}:{" "}
            {t(`step.${status}`)}
          </span>
        }
      >
        {dot}
      </Popover>
    );
  };

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb
            items={[
              { title: t("home.header"), href: "/" },
              { title: t("configuration.header"), href: "/configuration/company" },
              { title: t("company_setting.header"), href: "/configuration/company" },
              { title: t("common.create") },
            ]} />
          <h2>{t('common.create')}</h2>
        </Flex>

        <Card style={{ border: "solid 1px #EAECF0" }}>
          <Space direction="vertical" size={44}>
            {/* <Steps
            current={currentStep}
            progressDot={customDot}
            items={STEPS.map((step) => {
              return {
                ...step,
                title: t(`company_profile.label.${step.i18n_key}`),
              };
            })}
          /> */}
            {/* {currentStep === 0 ? ( */}
            <Formik
              enableReinitialize
              onSubmit={onCompanyCreateSubmit}
              initialValues={{ ...infoInitialValues, ...infoValues }}
              validationSchema={infoSchema}
            >
              {({ values, errors, setFieldValue, setTouched }) => {
                console.log("values", values, errors);
                const onUpload = (info) => {
                  setFieldValue("companyLogo", info.file);
                  getBase64(info.file, (url) => {
                    setLoading(false);
                    setImageUrl(url);

                  });
                };

                const onRemove = () => {
                  setLoading(false);
                  setImageUrl(null);
                  setFieldValue("companyLogo", null);
                };

                const onAvatarChange = async (info) => {
                  setLoading(true);
                  const compressImg = await service.compressedImage({
                    file: info.file
                  })
                  getBase64(compressImg.data, (url) => {
                    console.log("url2 ", url);
                    setLoading(false);
                    setFieldValue("companyLogo", dataURLtoFile(url));
                    setImageUrl(url);
                  });
                };

                const onClearAvatar = (e) => {
                  e.stopPropagation();
                  setFieldValue("companyLogo", null);
                  setLoading(false);
                  setImageUrl(null);
                };
                const beforeUpload = (file) => {
                  return false;
                };
                const uploadButton = (
                  <button
                    style={{
                      border: 0,
                      background: "none",
                    }}
                    type="button"
                  >
                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                    <div
                      style={{
                        marginTop: 8,
                      }}
                    >
                      {t("common.upload")}
                    </div>
                  </button>
                );

                const onProviceChange = (val) => {
                  handleProviceChange(val);
                  setFieldValue("districtId", null);
                  setFieldValue("subdistrictId", null);
                  setFieldValue("zipCode", null);
                  setTouched(
                    {
                      districtId: false,
                      subdistrictId: false,
                      zipCode: false,
                    },
                    false
                  );
                };

                const onDistrictChange = (val) => {
                  handleDistrictChange(val);
                  setFieldValue("subdistrictId", null);
                  setFieldValue("zipCode", null);
                  setTouched(
                    {
                      subdistrictId: false,
                      zipCode: false,
                    },
                    false
                  );
                };

                const onSubDistrictChange = (_, selectedValue) => {
                  setFieldValue("zipCode", selectedValue.zipCode || null);
                  setTouched({ zipCode: false }, false);
                };

                return (
                  <Form>
                    <Space style={{
                      width: "100%"
                    }} direction="vertical" size={24} justify="center">
                      <Flex justify="center">
                        <Upload
                          name="companyLogo"
                          listType="picture-circle"
                          className={styles.avatarUploader}
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                          onChange={async (info) => onAvatarChange(info)}
                          action={null}
                        >
                          {imageUrl ? (
                            <>
                              <img
                                src={imageUrl}
                                alt="companyLogo"
                                className={styles.avatar}
                                style={{
                                  width: "100%",

                                }}
                              />
                              <MinusCircleOutlined
                                className={styles.avatarMinusIcon}
                                onClick={onClearAvatar}
                              />

                            </>
                          ) : (
                            uploadButton
                          )}
                        </Upload>
                      </Flex>

                      <CompanyInfo
                        values={values}
                        setFieldValue={setFieldValue}
                        getTaxConpanyOption={getTaxConpanyOption}
                        optionSearchTax={optionSearchTax}
                        companyTypeOptions={companyTypeOptions}
                      />

                      <Addressinformation
                        provinceOptionsTh={provinceOptionsTh}
                        provinceOptionsEn={provinceOptionsEn}
                        districtOptionsTh={districtOptionsTh}
                        districtOptionsEn={districtOptionsEn}
                        subDistrictOptionsTh={subDistrictOptionsTh}
                        subDistrictOptionsEn={subDistrictOptionsEn}
                        onProviceChange={(_, item) => {
                          onProviceChange(item?.provinceCode)
                        }}
                        onDistrictChange={(_, item) => {
                          onDistrictChange(item?.districtCodeId)
                        }}
                        onSubDistrictChange={onSubDistrictChange}
                      />

                      <ContactInfo />

                      <Row justify="end">
                        <Space size={10}>
                          <Button type="default" style={{ borderRadius: "8px", height: "40px" }} onClick={onCancel}>
                            {t("common.cancel").toUpperCase()}
                          </Button>
                          <Button htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", border: "none", color: "white" }}>
                            {t("common.create").toUpperCase()}
                          </Button>
                        </Space>
                      </Row>
                    </Space>
                  </Form>
                );
              }}
            </Formik>
          </Space>
        </Card>
      </Space>
    </MainLayout >
  );
};

export default CompanyProfileCreate;
